// Module-level signal for the manual HDRI override picked in the
// HDRISwitcher UI. When set, takes precedence over EnvProbe's
// splat-derived envMap; when null, EnvProbe owns scene.environment.
//
// Two callers:
//   • HDRISwitcher (DOM dropdown)        — calls setHdriOverride()
//   • HDRIApplier (inside Canvas)        — subscribes via useHdriOverride()

import { useSyncExternalStore } from 'react'

let _value = null   // { url, label } | null
const _subs = new Set()

export function getHdriOverride() {
  return _value
}

export function setHdriOverride(next) {
  if (_value?.url === (next?.url ?? null)) return
  _value = next
  _subs.forEach(fn => fn())
}

function subscribe(fn) {
  _subs.add(fn)
  return () => _subs.delete(fn)
}

export function useHdriOverride() {
  return useSyncExternalStore(subscribe, getHdriOverride, getHdriOverride)
}
